module.exports = __webpack_public_path__ + "assets/discount_orange-fa5b91.svg";